import { render, staticRenderFns } from "./setting-theme.vue?vue&type=template&id=342dcaac&scoped=true&"
import script from "./setting-theme.vue?vue&type=script&lang=js&"
export * from "./setting-theme.vue?vue&type=script&lang=js&"
import style0 from "./setting-theme.vue?vue&type=style&index=0&id=342dcaac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342dcaac",
  null
  
)

export default component.exports